import React from 'react'
import {Button, Modal, Label, ModalHeader, ModalBody, ModalFooter, FormGroup} from 'reactstrap'
import apiBarcode from '../../../services/api/apiBarcode'
import {pushNewItemHistory} from "../../../services/api/apiItemHistory"
import StandardAddress from "./EditAddress/StandardAddress"
import GhtkAddress from "./EditAddress/GHTKAddress"
import {detectCarrierShippingRule} from "../../../services/api/apiPacking"
import { Input } from 'antd'
import { generateLabelByCustomData, generateLabelByLabelId } from '../../../services/api/apiNextBarcode'
import { mappingLineShip } from '../ListItemsTable/ParentRow'

class ModalGenLabelCustomWHL extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            weight: '',
            length: '',
            width: '',
            height: '',
            isLoadingSave: false,
            errorValidate: {}
        }
    }

    _handleChangeInput = (e) => {
        const {errorValidate} = this.state
        const {name, value} = e.target
        const newErrorValidate = { ...errorValidate }
        if(newErrorValidate[name]){
            delete newErrorValidate[name]
        }
        
        this.setState({
            [name]: value,
            errorValidate: newErrorValidate
        })
    }

    _renderIconLoading = () => {
        if (this.state.isLoadingSave)
            return <i className='icon-spinner2 spinner ml-2'/>
    }

    _handleValidate = () => {
        const errorValidate = {}
        const {weight, length, width, height} = this.state

        if (weight === '') {
            errorValidate.weight = 'Please input weight!!!'
        }
        if (length === '') {
            errorValidate.length = 'Please input length!!!'
        }
        if (width === '') {
            errorValidate.width = 'Please input width!!!'
        }
        if (height === '') {
            errorValidate.height = 'Please input height!!!'
        }
        
        const checkWeight = !!errorValidate.weight && errorValidate.weight !== ''
        const checkLength = !!errorValidate.length && errorValidate.length !== ''
        const checkWidth = !!errorValidate.width && errorValidate.width !== ''
        const checkHeight = !!errorValidate.height && errorValidate.height !== ''

        this.setState({
            errorValidate
        })
        if (checkWeight || checkLength || checkWidth || checkHeight) {
            return true
        }
        return false
    }

    _handleClickSave = async () => {
        const validate = this._handleValidate()

        if (validate) return

        this.setState({isLoadingSave: true})

        try {
            const {item, reload, toggle} = this.props
            const {barcodeNumber} = item
            const {weight, width, length, height} = this.state

            const rawId = item.meta && item.meta.label && item.meta.label.id
            const labelId = rawId && /^[a-f\d]{24}$/i.test(String(rawId))
                ? rawId
                : item.meta && item.meta.label && item.meta.label._id
            let success, message

            if (labelId) {
                // Luồng MỚI: gọi fulfillment API + custom_whl_data
                const payload = {
                    trigger: 'manual',
                    custom_whl_data: {
                        weight: +weight,
                        height: +height,
                        length: +length,
                        width: +width,
                    }
                }
                const result = await generateLabelByLabelId(labelId, payload)
                success = result.success
                message = result.message
            } else {
                // Luồng CŨ
                const payload = {
                    data: {
                        weight: +weight,
                        height: +height,
                        length: +length,
                        width: +width,
                    }
                }
                const result = await generateLabelByCustomData(barcodeNumber, payload)
                success = result.success
                message = result.message
            }

            if (!success) {
                this.setState({isLoadingSave: false})
                throw new Error(message)
            }

            this.setState({
                isLoadingSave: false
            }, async () => {
                await reload()
                toggle()
            })
        } catch (e) {
            alert(e.message)
        }
    }

    _diff = (oldObj, newObj) => {
        return Object.entries(newObj).map(([key, value]) => {
            if (oldObj[key] !== newObj[key]) {
                return key
            }
            return null
        }).filter(Boolean)
    }

    render() {
        const {isOpen, toggle, className, item} = this.props
        const {isLoadingSave, weight, length, width, height, errorValidate} = this.state
        const {labelDetails = {}} = item || {}
        const lineShip = mappingLineShip(labelDetails && labelDetails.shipping_carrier) || {}

        return (
            <div>
                <Modal isOpen={isOpen} toggle={toggle} className={className}>
                    <ModalHeader toggle={toggle}>Generate label {lineShip.name ? `${lineShip.name} ` : ''}by custom data</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label>Weight</Label>
                            <Input type='number' name='weight' value={weight} addonAfter="gram" onChange={this._handleChangeInput}/>
                            {errorValidate['weight'] &&
                                <div className='text-danger mt-1'>{errorValidate['weight']}</div>
                            }
                        </FormGroup>
                        <FormGroup>
                            <Label>Length</Label>
                            <Input type='number' name='length' value={length} addonAfter="cm" onChange={this._handleChangeInput}/>
                            {errorValidate['length'] &&
                                <div className='text-danger mt-1'>{errorValidate['length']}</div>
                            }
                        </FormGroup>
                        <FormGroup>
                            <Label>Width</Label>
                            <Input type='number' name='width' value={width} addonAfter="cm" onChange={this._handleChangeInput}/>
                            {errorValidate['width'] &&
                                <div className='text-danger mt-1'>{errorValidate['width']}</div>
                            }
                        </FormGroup>
                        <FormGroup>
                            <Label>Height</Label>
                            <Input type='number' name='height' value={height} addonAfter="cm" onChange={this._handleChangeInput}/>
                            {errorValidate['height'] &&
                                <div className='text-danger mt-1'>{errorValidate['height']}</div>
                            }
                        </FormGroup>     
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggle}>Cancel</Button>{' '}
                        <Button color="primary" onClick={this._handleClickSave} disabled={isLoadingSave}>
                            Generate
                            {this._renderIconLoading()}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default ModalGenLabelCustomWHL
